module.exports = __webpack_public_path__ + "img/guide_vi.400dea2.webp";